export const criteria = [
  {
    title: "Innovation & Distinction",
    description:
      "Work should demonstrate innovation and distinction in solving the problem.",
  },
  {
    title: "Impact",
    description:
      "Work should have a clear people impact with verifiable numbers. Increased geographical reach and ripple effects are a plus.",
  },
  {
    title: "Milestones",
    description: "Work should have demonstrable milestones of achievement.",
  },
  {
    title: "Duration/Sustainability",
    description: "Impact of work should be sustainable, and long-term.",
  },
  {
    title: "Diversity & Inclusion",
    description:
      "Work should reflect diversity and inclusion in impact and operations.",
  },
  {
    title: "Scandal History",
    description: "Person/work should be scandal-free.",
  },
];
